<template>
    <div class="packageImages">
        <img ref="bg" :src="ewmPath" alt width="45%" height="45%" v-show="false" />
        <div v-for="(item, index) in codeArr" :key="index" v-show="false">
            <vue-qr
                :id_name="'qcode_' + index"
                :qid="item.qid"
                :text="item.url"
                :margin="5"
                colorDark="black"
                colorLight="#fff"
                :size="200"
                :callback="getQcodeUrl"
            ></vue-qr>
        </div>
        <div class="circular">
            <v-progress-circular
                @click="packageImages"
                :rotate="360"
                :size="150"
                :width="4"
                :value="num"
                color="primary"
            >
                <div class="download">
                    <div></div>
                </div>
                <div class="text">
                    {{ text }}
                </div>
            </v-progress-circular>
        </div>
        <div class="prompt" v-if="text != '重新下载' && text != '点击下载' && text != '压缩完成'">
            压缩中....请勿退出
        </div>
        <el-button
            style="width: 7rem;margin-top:1.5rem"
            @click="cancal"
            v-if="num == '100' || !num"
        >
            退出
        </el-button>
        <!-- <el-upload action=""
            multiple :show-file-list="false"
            style="display: contents"
            accept=".xls,.XLS,.xlsx,.XLSX"
            :limit="3"
            :http-request="httpRequest">
            <el-button type="primary" icon="el-icon-upload2">导入</el-button>
        </el-upload> -->
    </div>
</template>
<script>
import util from "@/util";
import { mapState } from "vuex";
import store from "@/store";
String.prototype.byteLength = function() {
    var length = 0;
    Array.from(this).map(function(char) {
        if (char.charCodeAt(0) > 255) {
            //字符编码大于255，说明是双字节字符
            length += 2;
        } else {
            length++;
        }
    });

    return length;
};
String.prototype.pxWidth = function(font) {
    var canvas =
            String.prototype.pxWidth.canvas ||
            (String.prototype.pxWidth.canvas = document.createElement("canvas")),
        context = canvas.getContext("2d");
    font && (context.font = font);
    var metrics = context.measureText(this);
    return metrics.width;
};
import vueQr from "vue-qr";
import JSZip from "jszip";
import FileSaver from "file-saver";
import xlsx from 'xlsx';
export default {
    data() {
        return {
            codeArr: [],
            num: 0,
            text: "点击下载",
            jsondata: [], // 导入后转换成json
            numbersuccess: 0, // 导入成功数
            numberusered: 0, // 已存在数
            resdata: []// 导入post请求返回的值

        };
    },
    components: {
        vueQr,
    },
    computed: {
        ...mapState(["connectorInfo", "ewmPath"]),
    },
    props: {
        siteId: null,
        siteName: null,
    },
    watch: {
        num: {
            handler(val) {
                if (val != "100") {
                    this.text = "压缩中...  " + val + "%";
                } else {
                    this.text = "压缩完成";
                    let that = this;
                    setTimeout(() => {
                        that.text = "重新下载";
                    }, 2000);
                }
            },
            deep: true,
        },
    },
    async mounted() {
        await this.getConnector();
        // http://ecar.meisenpay.com/evc/
        for (let i = 0; i < this.connectorInfo.length; i++) {
            this.codeArr.push({
                url: "http://ecar.meisenpay.com/evc/" + this.connectorInfo[i].connector_id, // 二维码的地址
                connector_id: this.connectorInfo[i].connector_id, // 设置每一个二维码的文件名
                imgSrc: "", // 生成的二维码放图片的字段
                lastUrl: "", //最终的图片地址
                connName: this.connectorInfo[i].name, //每把枪的名字
                qid: this.connectorInfo[i].id.toString(),
                siteName: this.siteName,
            });
        }
        console.log(this.codeArr)
    },
    methods: {
        /*获取充电枪数据*/
        async getConnector() {
            let postData = {
                station_id: this.siteId,
            };
            await store.dispatch("getConnector", postData);
        },
        /*获取到二维码图片*/
        getQcodeUrl(url, name) {
            let index = Number(name);
            for (let i = 0; i < this.codeArr.length; i++) {
                if (index == this.codeArr[i].qid) {
                    this.codeArr[i].imgSrc = url;
                }
            }
        },
        /*合并图片*/
        onCreateCanvas(src, connector_id, img2,siteName) {
            let img = new Image();
            img.src = src;
            let imgHeight = img.naturalHeight;
            let imgWidth = img.naturalWidth;
            //构建画布;
            const canvas = document.createElement("canvas");
            let context = canvas.getContext("2d");
            
            /*生成带背景图的二维码图片*/
            let img2Height = img2.naturalHeight + 60;
            let img2Width = img2.naturalWidth + 60;
            canvas.height = 2008 //整张图的高度度
            canvas.width = 1475; //整张图的宽度
            let ewmHeight = 500; //二维码图片高度
            let ewmwidth = 500; //二维码图片宽度
            let left_x = 860; //二维码距离左边
            let top_y = 520; //二维码距离顶部边
            context.drawImage(img2, 0, 0, img2Width, img2Height); // 加入背景图
            context.drawImage(img, 0, 0, imgWidth, imgHeight, left_x, top_y, ewmwidth, ewmHeight); //在背景图上加上二维码图片
            context.fillStyle = "black"; // 设置文字的填充颜色
            context.font = "normal 45px normal"; // 设置文字的填充样式
            let ll = ewmwidth / 2 + left_x - connector_id.pxWidth(context.font) / 2;  //设置编号在图片上所处的位置
            context.fillText(connector_id, ll, top_y + ewmHeight + 60);  //在图片上添加编号
            let a = siteName.match(/美森宝-(\S*)/) ? siteName.match(/美森宝-(\S*)/)[1] : siteName;
            let ll2 = ewmHeight / 2 + left_x - a.pxWidth(context.font) / 2;
            context.fillText(a, ll2, top_y + ewmHeight + 115);
            
            /*生成黑色背景带编号的二维码*/ 
            /*canvas.height = 827;
            canvas.width = 1417;
            let ewmHeight = 400; //二维码图片高度
            let ewmwidth = 400; //二维码图片宽度
            context.fillRect(0,0,1417,827);
            // context.drawImage(img, 0, 0, imgWidth, imgHeight);
            context.drawImage(img, canvas.width / 2 - ewmwidth / 2, canvas.height/2 - ewmHeight / 2, ewmwidth, ewmHeight);
            context.fillStyle = "white"; // 设置文字的填充颜色
            context.font = "normal 40px normal"; // 设置文字的填充样式
            let ll = canvas.width / 2 - connector_id.pxWidth(context.font) / 2;
            context.fillText(connector_id, ll, canvas.height/2 + ewmHeight / 2 + 50);*/
            
            /*生成红边白底站点名称+编号的图片*/ 
           /* canvas.width = 1063; //整张图的宽度
            canvas.height = 591 //整张图的高度度
            let img2Height = img2.naturalHeight;
            let img2Width = img2.naturalWidth;
            context.drawImage(img2, 0, 0, img2Width, img2Height); // 加入背景图
            context.fillStyle = "red"; // 设置文字的填充颜色
            context.font = "normal 65px normal"; // 设置文字的填充样式
            let ll = canvas.width / 2  - siteName.pxWidth(context.font) / 2;
            let hh = canvas.height / 4 + 35;
            context.fillText(siteName, ll, hh); 
            let ll2 = canvas.width / 2  - connector_id.pxWidth(context.font) / 2;
            let hh2 = canvas.height / 2 + canvas.height / 4;
            context.fillText(connector_id, ll2, hh2); */
			
			 /*生成白底只带二维码和编号的图片*/ 
			/*canvas.height = 500;
			canvas.width = 420;
			let ewmHeight = 400; //二维码图片高度
			let ewmwidth = 400; //二维码图片宽度
			context.fillStyle = '#fff';
			context.fillRect(0,0,420,500);
			// context.drawImage(img, 0, 0, imgWidth, imgHeight);
			context.drawImage(img, 10, 10, ewmwidth, ewmHeight);
			context.fillStyle = "black"; // 设置文字的填充颜色
			context.font = "normal 40px normal"; // 设置文字的填充样式
			let ll = canvas.width / 2 - connector_id.pxWidth(context.font) / 2;
			context.fillText(connector_id, ll, canvas.height/2 + ewmHeight / 2 + 20);*/
            
            
            var url = canvas.toDataURL("image/png");
            return url;
        },
        /*下载*/
        packageImages() {
            if (this.connectorInfo.length == 0) {
                util.ShowTip("未查找到枪信息", 3);
                return;
            }
            this.num = "1";
            setTimeout(() => {
                this.download();
            }, 1000);
        },
        async download() {
            await this.dealImg();
            const zip = new JSZip();
            const cache = {};
            const arr = this.codeArr;
            try {
                arr.forEach(item => {
                    // 设置生成的文件名
                    const fileName = item.connName + "-" + item.connector_id;
                    // 文件名加文件流加格式
                    zip.file(`${fileName}.png`, item.lastUrl.substring(22), {
                        base64: true,
                    });
                    cache[fileName] = item.lastUrl;
                });
                let that = this;
                zip.generateAsync(
                    {
                        type: "blob",
                        compression: "DEFLATE", // 压缩算法
                        compressionOptions: {
                            // 压缩级别
                            level: 9,
                        },
                    },
                    function updateCallback(metadata) {
                        that.num = metadata.percent.toFixed(0);
                    }
                )
                    .then(content => {
                        FileSaver.saveAs(content, that.siteName + ".zip"); //这里设置压缩包的名称
                        // that.codeArr = [];
                    })
                    .catch(error => {
                        console.log(error);
                        // that.codeArr = [];
                        util.ShowTip("压缩图片失败：" + error, 3);
                    });
            } catch (error) {
                console.log(error);
            }
        },
        /*处理图片*/
        dealImg() {
            let img2 = this.$refs.bg;
            for (let i = 0; i < this.codeArr.length; i++) {
                let url = this.onCreateCanvas(
                    this.codeArr[i].imgSrc,
                    this.codeArr[i].connector_id,
                    img2,
                    this.codeArr[i].siteName
                );
                this.codeArr[i].lastUrl = url;
            }
        },
        cancal() {
            this.$emit("cancal");
        },
        httpRequest (e) {
            let file = e.file // 文件信息
            // 错误情况判断
            if (!file) {
                return false
            } else if (!/\.(xls|xlsx)$/.test(file.name.toLowerCase())) {
                this.$message.error('上传格式不正确，请上传xls或者xlsx格式')
                return false
            }
            let that = this;
            const fileReader = new FileReader()// 读取文件
            fileReader.onload = (ev) => {
                try {
                    const data = ev.target.result// 获取结果
                    // 获取所有表的信息
                    const workbook = xlsx.read(data, {
                        type: 'binary', // 以字符编码的方式解析
                        cellDates: true// 将excel中日期类型数据，转化为标准日期格式，而不是默认的数字格式
                    })
                    console.log(workbook)
                    // 获取表名
                    const exlname = workbook.SheetNames[3]
                    // 转换成json数据
                    const exl = xlsx.utils.sheet_to_json(workbook.Sheets[exlname]) // 生成json表格内容
                    console.log(exl)
                    let arr = []
                    for(let i = 0;i<exl.length ;i++) {
                        let obj = exl[i];
                        let data = {
                            siteName: null,
                            data:[]
                        }
                        Object.keys(obj).forEach((key) => {
                            console.log(key)
                            if(key === "站点名称") {
                                data.siteName = obj[key];
                            }else {
                                data.data.push(obj[key])
                            }
                            // console.log(obj[key]) // foo
                        })
                        arr.push(data)
                    }
                    that.codeArr = []
                    for(let i = 0;i<arr.length;i++) {
                        for(let j = 0;j<arr[i].data.length;j++) {
                            let connector_id = arr[i].data[j]
                            that.codeArr.push({
                                url: "http://ecar.meisenpay.com/evc/" + connector_id, // 二维码的地址
                                connector_id: connector_id, // 设置每一个二维码的文件名
                                imgSrc: "", // 生成的二维码放图片的字段
                                lastUrl: "", //最终的图片地址
                                connName: arr[i].siteName, //每把枪的名字
                                qid: arr[i].siteName + connector_id.toString(),
                                siteName: arr[i].siteName,
                            });
                        }
                    }
                    console.log(that.codeArr)
                } catch (e) {
                    console.log(e)
                    console.log('error')
                    return false
                }
            }
            fileReader.readAsBinaryString(file)
        },
    },
};
</script>
<style scoped>
.packageImages {
    width: 100%;
    height: 20rem;
    background-color: #ffffff;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
}
.circular {
    width: 10rem;
    height: 10rem;
    position: relative;
}
.text {
    width: 10rem;
    height: 10rem;
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    border-radius: 50%;
    color: #ffffff;
    margin-top: -0.3rem;
    margin-left: -0.3rem;
    cursor: pointer;
    /* background-color: red; */
}
.download {
    width: 8rem;
    height: 8rem;
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    top: 0rem;
    left: 0;
    right: 0;
    /* background-color: red; */
    border-radius: 50%;
    position: relative;
    background: linear-gradient(120deg, #34e0f0 0%, #b400ff 100%);
    opacity: 0.8;
    animation: rotateMain 4s linear infinite;
    cursor: pointer;
}
.download ::before {
    border-radius: 50%;
    position: absolute;
    content: "";
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(180deg, #35a0f0 0%, #b233f0 100%);
    opacity: 0.8;
    box-shadow: 5px 5px 90px rgba(10, 102, 255, 0.5);
    border-radius: 35%;
    animation: rotateMain 4s linear 2s infinite;
}

.download ::after {
    border-radius: 50%;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(60deg, #33580f 0%, #b7ee6d 100%);
    opacity: 0.8;
    box-shadow: 5px 5px 60px rgba(20, 102, 255, 0.3);
    border-radius: 35%;
    animation: rotateMain 4s linear 4s infinite;
    z-index: -1;
}

@keyframes rotateMain {
    25% {
        transform: rotateZ(90deg);
        border-radius: 25%;
    }
    37.5% {
        transform: rotateZ(135deg);
        border-radius: 37.5%;
    }
    50% {
        transform: rotateZ(180deg);
        border-radius: 50%;
    }
    62.5% {
        transform: rotateZ(225deg);
        border-radius: 62.5%;
    }
    75% {
        transform: rotateZ(270deg);
        border-radius: 75%;
    }
    87.5% {
        transform: rotateZ(315deg);
        border-radius: 87.5%;
    }
    100% {
        transform: rotateZ(360deg);
        border-radius: 35%;
    }
}
.prompt {
    margin-top: 1.5rem;
    animation: shake-baidu 1.5s ease 0s infinite;
}
@keyframes shake-baidu {
    from {
        transform: rotate(0deg);
    }
    4% {
        transform: rotate(5deg);
    }
    12.5% {
        transform: rotate(-5deg);
    }
    21% {
        transform: rotate(5deg);
    }
    29% {
        transform: rotate(-5deg);
    }
    37.5% {
        transform: rotate(5deg);
    }
    46% {
        transform: rotate(-5deg);
    }
    50%,
    to {
        transform: rotate(0deg);
    }
}
</style>
